import { AboutComponent } from './about.component';
import { Routes } from '@angular/router';

export const ABOUT_ROUTES: Routes = [{
    path: 'about',
    component: AboutComponent,
    data: {
        pageTitle: 'about.browser.title'
    }
}];
